import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import UseNewsSubmit from "hooks/NewsSubmit";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Input } from "@windmill/react-ui";
import Uploader from "components/image-uploader/Uploader";
import { FiX } from "react-icons/fi";
import { useState } from "react";
const NewsDrawer = ({ id }) => {
    const [preview, setPreview] = useState(null);

    const {
        register,
        handleSubmit,
        onSubmit,
        errors,
        NewsUrl,
        setNewsUrl
    } = UseNewsSubmit(id);

    const handleCancelImage = (value) => {
        if (value === "news") setNewsUrl("");
    };


    return (
        <>
            <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
                {id ? (
                    <Title title={"Edit News"} description={""} />
                ) : (
                    <Title title={"Add News"} description={""} />
                )}
            </div>

            <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
                <div>
                    {preview && (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="relative bg-white p-4 rounded shadow-lg">
                                <button
                                    onClick={() => setPreview(null)}
                                    style={{ position: "absolute", right: "12px", top: "6px", fontSize: "30px", color: "#333", cursor: "pointer", hover: { color: "red" } }}
                                >
                                    ×
                                </button>
                                <img
                                    style={{ width: "500px", height: "auto", objectFit: "contain", padding: "20px" }}
                                    src={preview}
                                    alt="Preview"

                                />

                            </div>
                        </div>
                    )}

                </div>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
                        <div className="gap-3 mb-6">

                            <div
                                className="grid grid-cols-6 gap-3 mb-6"
                                style={{ display: "block", justifyContent: "space-between" }}
                            >

                                <div style={{ width: "100%" }}>
                                    <LabelArea label={"Title"} />
                                    <Input
                                        {...register("title")}
                                        className="border h-10 text-sm focus:outline-none block bg-white-100 dark:bg-white border-transparent focus:bg-white mb-2"
                                        placeholder="Title"
                                    />
                                    {errors?.title && (
                                        <Error errorName={errors.title.message} />
                                    )}
                                </div>


                                <div style={{ width: "100%" }}>
                                    <LabelArea label={"Description"} />
                                    <Input
                                        {...register("description")}
                                        className="border h-10 text-sm focus:outline-none block bg-white-100 dark:bg-white border-transparent focus:bg-white mb-2"
                                        placeholder="Description"
                                    />
                                    {errors?.description && (
                                        <Error errorName={errors.description.message} />
                                    )}
                                </div>
                            </div>
                            <div className="hidden xl:block">
                                <LabelArea label={"Image"} />
                            </div>

                            <input
                                type="hidden"
                                {...register("news_image")}
                            />

                            {NewsUrl ? (
                                <div className="relative inline-block max-w-full w-[358px] h-48 bg-gray-100 rounded-lg flex items-center justify-center">


                                    <img
                                        className="object-contain rounded-lg h-48 w-full max-w-md bg-gray-100 cursor-pointer"
                                        src={`${process.env.REACT_APP_API_IMAGE_URL}${NewsUrl}`}
                                        alt="News"
                                        onClick={() =>
                                            setPreview(`${process.env.REACT_APP_API_IMAGE_URL}${NewsUrl}`)
                                        }
                                    />


                                    <FiX
                                        size={20}
                                        style={{ top: '0.5rem', right: '0.5rem', position: 'absolute' }}
                                        className="cursor-pointer p-1 rounded-full bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:text-red-500 dark:hover:text-red-400 shadow-sm"
                                        onClick={() => handleCancelImage("news")}
                                        onKeyDown={(e) => e.key === "Enter" && handleCancelImage("news")}
                                        tabIndex={0}
                                        aria-label="Remove News image"
                                    />

                                </div>

                            ) : (
                                <Uploader
                                    is_multiple={false}
                                    folder="News"
                                    name_merge="NEWS_IMAGE"
                                    imageUrl={NewsUrl}
                                    setImageUrl={setNewsUrl}
                                    no_of_image={1}
                                />
                            )}


                            <div className="hidden xl:block mt-5 ">
                                <LabelArea label={"Url"} />
                            </div>

                            <Input
                                {...register("url")}
                                className="border h-10 text-sm focus:outline-none block bg-white-100 dark:bg-white border-transparent focus:bg-white mb-2"
                                placeholder="Url"
                            />
                            {errors?.url && (
                                <Error errorName={errors.url.message} />
                            )}

                        </div>
                    </div>

                    <DrawerButton id={id} title={id ? "Update" : "Submit"} />
                </form>
            </Scrollbars>
        </>
    );
};

export default NewsDrawer;
